export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DashboardLibrarian.vue?vue&type=template&id=1acf0120&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/dashboard/DashboardLibrarian.vue?vue&type=template&id=1acf0120&scoped=true&
// module id = 965
// module chunks = 0